import { WalkSVG } from "./SVGIllustrations";
import { TextInput } from "@/components/we360/TextInput";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { AlertBanner } from "@/components/we360/AlertBanner";

export default function Step3Walk({ value, onChange, classification, sex, isDefaultSex, errors, onBlur }) {
  return (
    <div>
      <div className="text-center mb-2">
        <WalkSVG meters={value} sex={sex} />
      </div>

      <div
        className="rounded-[14px] p-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
        data-testid="f2-walk-instructions"
      >
        Camina lo más rápido que puedas durante <strong>6 minutos</strong> en un lugar plano y seguro.
        Mide la distancia total recorrida.
      </div>

      <TextInput
        label="Metros recorridos"
        value={value}
        onChange={onChange}
        onBlur={() => onBlur?.("caminata6min")}
        placeholder="450"
        suffix="m"
        type="number"
        min="0"
        max="1000"
        error={errors?.getError("caminata6min")}
        testId="input-caminata"
      />

      {classification && (
        <>
          <CalculatedBadge
            label="Caminata 6 min"
            value={`${value}m`}
            category={classification.label}
            categoryColor={classification.color}
            testId="badge-caminata"
          />
          {isDefaultSex && (
            <AlertBanner variant="info" testId="alert-default-sex-walk">
              Clasificacion usando valores de referencia generales.
            </AlertBanner>
          )}
        </>
      )}
    </div>
  );
}
